import type { RuleParameterDefinition } from "@/api";

type Unit = RuleParameterDefinition["unit"];

export function ruleValueNumber(value: number, unit: Unit): number {
  return unit === "eur_cents" ? value / 100 : value;
}

/** Convert the display unit only; the server validates types, ranges, steps and invariants. */
export function parseRuleValueInput(value: string, unit: Unit): unknown {
  const trimmed = value.trim();
  if (!trimmed || !Number.isFinite(Number(trimmed))) return value;
  const scaled = Number(trimmed) * (unit === "eur_cents" ? 100 : 1);
  const integer = Math.round(scaled);
  return Math.abs(scaled - integer) <= Number.EPSILON * Math.abs(scaled) * 2 ? integer : scaled;
}

export function formatRuleMoney(cents: number, lang: "de" | "en"): string {
  return `${(cents / 100).toLocaleString(lang === "de" ? "de-DE" : "en-GB", {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  })} EUR`;
}
